<template>
	<div class="supplier-modal modal-small" tabindex="0">
		<h3>CAP Commitment Form</h3>
		<h4>{{result.SupplierName}}</h4>

		<div class="terms-agree">
			<p>By clicking below, I agree to drop this CAP Supplier and forfeit any future CAP Rebates provided.</p>
			<button v-on:click="accept()" v-on:keydown.enter="accept()">I Agree</button>
			<button v-on:click="cancel()" v-on:keydown.enter="cancel()">Cancel</button>
		</div>
	</div>


</template>

<script>
	import * as ModalResponse from '../../common/modal-response';

	export default {
		props: {

		},
		data: function () {
			return {

			}
		},
		mounted() {
			$('.supplier-modal').focus();
		},
		methods: {

			accept: function () {
				this.removeDim();
				$('#program-' + this.result.itemID).focus();
				this.$close(ModalResponse.SUPPLIER_REMOVED);
			},
			cancel: function () {
				this.removeDim();
				$('#program-' + this.result.itemID).focus();
				this.$close(ModalResponse.CANCELLED);
			},
			removeDim: function () {
				document.getElementsByTagName('body')[0].classList.remove('dim');
			}
		}
	}

</script>